/**
 * QL-414 — the one shape a stored currency code may take: a three-letter
 * upper-case ISO 4217 code ("NOK", "EUR"). Flow and collection currencies are
 * validated with it on write, and PDF renderers print only a code that passes,
 * so a code never needs escaping where it is interpolated into Typst.
 */
export function isCurrencyCode(value: unknown): value is string {
  return typeof value === "string" && /^[A-Z]{3}$/.test(value);
}

/**
 * The currency used when none is set: new flows, collections, tenants and
 * accounts start in it, and readers fall back to it for a missing value.
 * Billing (EUR) and instrument data (USD) have their own defaults.
 */
export const DEFAULT_CURRENCY = "NOK";

/**
 * The currency of the "Standard" portfolio collection template. The API clones
 * the template with it and the create dialog preselects it, so both read it here.
 */
export const STANDARD_TEMPLATE_CURRENCY = "EUR";
